import { adminHttp } from "./adminApi";

const q = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );

// IMPORTANT:
// adminHttp ka baseURL API_BASE hai.
// Inventory backend router /api/inventory par mounted hai.
const INVENTORY = "/api/inventory";

export const inventoryApi = {
  // Dashboard
  dashboard: async () =>
    (await adminHttp.get(`${INVENTORY}/dashboard`)).data,

  // Masters
  listMasters: async (type) =>
    (
      await adminHttp.get(`${INVENTORY}/masters`, {
        params: q({ type }),
      })
    ).data,

  addMaster: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/masters`, payload)).data,

  updateMaster: async (id, patch) =>
    (
      await adminHttp.patch(
        `${INVENTORY}/masters/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  deleteMaster: async (id) =>
    (
      await adminHttp.delete(
        `${INVENTORY}/masters/${encodeURIComponent(id)}`
      )
    ).data,

  importMasters: async (type, file) => {
    const fd = new FormData();
    fd.append("file", file);

    return (
      await adminHttp.post(
        `${INVENTORY}/import/masters?type=${encodeURIComponent(type)}`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    ).data;
  },

  // Smart Meters
  listSmart: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/smart-meters`, {
        params: q(params),
      })
    ).data,

  getSmart: async (id) =>
    (
      await adminHttp.get(
        `${INVENTORY}/smart-meters/${encodeURIComponent(id)}`
      )
    ).data,

  addSmart: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/smart-meters`, payload)).data,

  updateSmart: async (id, patch) =>
    (
      await adminHttp.patch(
        `${INVENTORY}/smart-meters/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  deleteSmart: async (id) =>
    (
      await adminHttp.delete(
        `${INVENTORY}/smart-meters/${encodeURIComponent(id)}`
      )
    ).data,

  importSmart: async (file) => {
    const fd = new FormData();
    fd.append("file", file);

    return (
      await adminHttp.post(`${INVENTORY}/import/smart-meters`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    ).data;
  },

  // Old Meters
  listOld: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/old-meters`, {
        params: q(params),
      })
    ).data,

  addOld: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/old-meters`, payload)).data,

  updateOld: async (id, patch) =>
    (
      await adminHttp.patch(
        `${INVENTORY}/old-meters/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  deleteOld: async (id) =>
    (
      await adminHttp.delete(
        `${INVENTORY}/old-meters/${encodeURIComponent(id)}`
      )
    ).data,

  importOld: async (file) => {
    const fd = new FormData();
    fd.append("file", file);

    return (
      await adminHttp.post(`${INVENTORY}/import/old-meters`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    ).data;
  },

  // Cables
  listCables: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/cables`, {
        params: q(params),
      })
    ).data,

  addCable: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/cables`, payload)).data,

  updateCable: async (id, patch) =>
    (
      await adminHttp.patch(
        `${INVENTORY}/cables/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  deleteCable: async (id) =>
    (
      await adminHttp.delete(
        `${INVENTORY}/cables/${encodeURIComponent(id)}`
      )
    ).data,

  importCables: async (file) => {
    const fd = new FormData();
    fd.append("file", file);

    return (
      await adminHttp.post(`${INVENTORY}/import/cables`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    ).data;
  },

  // Ledger
  ledger: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/ledger`, {
        params: q(params),
      })
    ).data,

  reportsSummary: async () =>
    (await adminHttp.get(`${INVENTORY}/reports/summary`)).data,

  reportXlsxUrl: (kind) =>
    `${INVENTORY}/reports/${encodeURIComponent(kind)}.xlsx`,

  // Installations
  listInstallations: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/installations`, {
        params: q(params),
      })
    ).data,

  addInstallation: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/installations`, payload)).data,

  // Gate Passes
  listGatePasses: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/gate-passes`, {
        params: q(params),
      })
    ).data,

  addGatePass: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/gate-passes`, payload)).data,

  updateGatePass: async (id, patch) =>
    (
      await adminHttp.patch(
        `${INVENTORY}/gate-passes/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  // Cable Issues
  listCableIssues: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/cable-issues`, {
        params: q(params),
      })
    ).data,

  addCableIssue: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/cable-issues`, payload)).data,

  // BI Signoffs
  listBISignoffs: async (params = {}) =>
    (
      await adminHttp.get(`${INVENTORY}/bisignoffs`, {
        params: q(params),
      })
    ).data,

  addBISignoff: async (payload) =>
    (await adminHttp.post(`${INVENTORY}/bisignoffs`, payload)).data,

  updateBISignoff: async (id, patch) =>
    (
      await adminHttp.patch(
        `${INVENTORY}/bisignoffs/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  // Serial History
  crossHistory: async (serial) =>
    (
      await adminHttp.get(
        `${INVENTORY}/history/serial/${encodeURIComponent(serial)}`
      )
    ).data,
};

export const MASTER_TYPES = [
  { key: "division", label: "Division" },
  { key: "sub_division", label: "Sub Division" },
  { key: "sdo", label: "SDO" },
  { key: "store", label: "Store" },
  { key: "agency", label: "Agency / Vendor" },
  { key: "installer", label: "Installer" },
  { key: "meter_make", label: "Meter Make" },
  { key: "meter_model", label: "Meter Model" },
  { key: "cable_type", label: "Cable Type" },
  { key: "cable_size", label: "Cable Size" },
  { key: "document_type", label: "Document Type" },
];

export const SM_STATUSES = [
  "Available",
  "Issued",
  "Installed",
  "Returned",
  "Damaged",
  "Defective",
];

export const OM_CONDITIONS = [
  "Good",
  "Repairable",
  "Damaged",
  "Burnt",
  "Defective",
  "Scrap",
];

export const OM_DEPOSITS = [
  "Pending",
  "Deposited",
  "Verified",
];